import { render } from "./ProductItemsCard.vue?vue&type=template&id=3fb547ec&scoped=true"
import script from "./ProductItemsCard.vue?vue&type=script&lang=js"
export * from "./ProductItemsCard.vue?vue&type=script&lang=js"

import "./ProductItemsCard.vue?vue&type=style&index=0&id=3fb547ec&scoped=true&lang=css"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3fb547ec"]])

export default __exports__